import type { NewsRaw } from "epsm-api-types/models";
import { NEWS_DATASET } from "../../../types";

type Props = {
	data: NewsRaw | Partial<NewsRaw> | null;
};

export const NewsRowUI: React.FC<Props> = ({ data }) => {
	if (!data) {
		return <p data-testid="no-data">No data</p>;
	}

	const { briefs = [], dataset, sector, title, summary } = data;

	const tickers = briefs
		.filter((el) => el.brief && !el.brief.includes("No significant events"))
		.map((item) => item.ticker)
		.join(", ");

	return (
		<div className="flex gap-1 cursor-pointer items-center">
			{dataset === NEWS_DATASET.BRIEF ? (
				<>
					<p data-testid="news-title-start" className="text-gold font-bold">
						{`${sector} Brief: `}
					</p>
					<p data-testid="news-title-tickers" className="text-gold">
						{tickers}
					</p>
				</>
			) : (
				<>
					<p data-testid="news-title" className="text-white">
						{title || ""}
					</p>
					<p className="text-light-gray" data-testid="news-summary">
						{summary || ""}
					</p>
				</>
			)}
		</div>
	);
};
